import PropTypes from 'prop-types';

const SkeletonGroup = ({ items, skeleton: Skeleton }) =>
  Array(items)
    .fill(0)
    .map((_, index) => <Skeleton key={index} />);

SkeletonGroup.propTypes = {
  items: PropTypes.number.isRequired,
  skeleton: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]).isRequired,
};

export default SkeletonGroup;
